import React from 'react';
import {string, func} from 'prop-types';
import FavoritesIcon from 'dibs-vg/dist/react/heart-outlined';
import styles from './mobileNavIcons.scss';

const URL_PATH_FAVORITES = '/favorites/items/';

export default function MobileNavFavorite(props) {
    return (
        <a className={props.className} onClick={() => props.onClick({path: URL_PATH_FAVORITES})}>
            <FavoritesIcon className={`${styles.icon} ${styles.favorite}`} />
        </a>
    );
}

MobileNavFavorite.propTypes = {
    className: string,
    onClick: func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavIcons/MobileNavFavorite.jsx